import useESTList from 'hooks/API/GET/useESTList';
import { useEffect } from 'react';
import { getRandomUid } from 'utilities/uuid.service';

function ESTDropDown({ enableAPI, value, handleChange, handleSelected, labelClass = '*' }) {
  const queryParams = `?mode=dropdown`;
  const { data, isLoading } = useESTList({ enabled: enableAPI, queryParams });

  useEffect(() => {
    handleSelected?.(data?.data?.find?.((d) => d?._id === value));
  }, [data?.data, handleSelected, value]);

  return (
    <>
      {isLoading ? (
        'Loading...'
      ) : (
        <>
          <label className={`w-100 ${labelClass}`} htmlFor="">
            Country
          </label>
          <div className="d-flex align-items-center">
            {data?.data?.map((option) => {
              const uid = getRandomUid();
              return (
                <span className="radioBlock" key={option._id}>
                  <input
                    type="radio"
                    id={uid}
                    name="_COUNTRY_PICKER_"
                    value={option._id}
                    data-label-key={option.key}
                    onChange={(event) => {
                      handleChange(event, option);
                    }}
                    checked={`${value}`.trim() === `${option._id}`}
                  />
                  <label htmlFor={uid} className={`${labelClass}`}>
                    {option.name}
                  </label>
                </span>
              );
            })}
          </div>
        </>
      )}
    </>
  );
}

ESTDropDown.defaultProps = {
  handleChange: () => {},
};

export default ESTDropDown;
